import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css';

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-venta-producto'}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPdfRegistrado={props.loadingPdfRegistrado}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Almacen',
                    dataIndex: 'almacen',
                    key: 'almacen',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroVendedor',
                    key: 'numeroVendedor',
                    sorter: true
                },
                {
                    title: 'Vendedor',
                    dataIndex: 'vendedor',
                    key: 'vendedor',
                    sorter: true
                },
                {
                    title: 'Tipo Vendedor',
                    dataIndex: 'tipoVendedor',
                    key: 'tipoVendedor',
                    sorter: true
                },
                {
                    title: 'Codigo Proyecto',
                    dataIndex: 'codigoProyecto',
                    key: 'codigoProyecto',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "200px" }}>{value}</div>
                    )
                },
                {
                    title: 'Codigo Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Unidad Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    sorter: true
                },
                {
                    title: 'Lote',
                    dataIndex: 'lote',
                    key: 'lote',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    align: 'right',
                    sorter: true
                },

                {
                    title: 'Precio Unitario',
                    dataIndex: 'precioUnitarioStr',
                    key: 'precioUnitarioStr',
                    sorter: true,
                },
                {
                    title: 'Descuento',
                    dataIndex: 'descuento',
                    key: 'descuento',
                    sorter: true,
                },
/*                 {
                    title: 'Cultivo',
                    dataIndex: 'cultivo',
                    key: 'cultivo',
                    sorter: true,
                },
                {
                    title: 'Fenológica',
                    dataIndex: 'fenologica',
                    key: 'fenologica',
                    sorter: true,
                }, */
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true,
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'nombreCliente',
                    key: 'nombreCliente',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "200px" }}>{value}</div>
                    )
                },
                {
                    title: 'Departmento',
                    dataIndex: 'departamento',
                    key: 'departamento',
                    sorter: true
                },
                {
                    title: 'Provincia',
                    dataIndex: 'provincia',
                    key: 'provincia',
                    sorter: true
                },
                {
                    title: 'Distrito',
                    dataIndex: 'distrito',
                    key: 'distrito',
                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'tipoComprobanteSunat',
                    key: 'tipoComprobanteSunat',
                    sorter: true
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambioStr',
                    key: 'tipoCambioStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'PEN',
                    dataIndex: 'totalSolesStr',
                    key: 'totalSolesStr',
                    sorter: true
                },
                {
                    title: 'USD',
                    dataIndex: 'totalDolaresStr',
                    key: 'totalDolaresStr',
                    sorter: true
                },
                {
                    title: 'Conversión en PEN',
                    dataIndex: 'totalDolaresConvertidoStr',
                    key: 'totalDolaresConvertidoStr',
                    sorter: true
                },

            ]}
        />
    );
}